import { isViewportLiteral } from "../pixel-accessor";
import { isPoint } from "../types";
import type {
  DistortionProcessorFactory,
  DistortionProcessorFactoryOptions,
} from "./DistortionProcessorFactory";
import type { DistortionProcessor } from "./DistortionProcessor";
import { ReversePixelMappingProcessor } from "./ReversePixelMappingProcessor";
import { SuperSamplingProxy } from "./SuperSamplingProxy";
import { RepageProxy } from "./RepageProxy";

/**
 * Base implementation of DistortionProcessor factory.
 */
export class BaseDistortionProcessorFactory
  implements DistortionProcessorFactory
{
  /**
   * @inheritDoc
   */
  create(options: DistortionProcessorFactoryOptions = {}): DistortionProcessor {
    const {
      asyncTimeout = 50,
      outputScaling = 1,
      repage = false,
      abortSignal,
    } = options;
    let processor: DistortionProcessor = new ReversePixelMappingProcessor(
      asyncTimeout,
      abortSignal
    );
    if (outputScaling !== 1) {
      processor = new SuperSamplingProxy(processor, outputScaling);
    }
    if (repage) {
      processor = new RepageProxy(
        processor,
        isPoint(repage) || isViewportLiteral(repage) ? repage : undefined
      );
    }
    return processor;
  }
}
